import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoadingComponent from "./LoadingComponent";
import { useEffect } from "react";

const ConfirmBookingForm = ({ setConfirmForm, crt }) => {
  // const { cart, totalQuantity, totalPrice, allNames } = useSelector(
  const { cart, totalQuantity, totalPrice } = useSelector(
    (state) => state.allCart
  );

  const services = cart.map((e) => e.fullName);

  // ------------------------------------------------
  const [loading, setLoading] = useState(false);

  // post ----------------------------------------------------------

  const [error, setError] = useState(null);
  const pageFullUrl = window.location.href;

  const selectedCityValue = useSelector((state) => state.city.cityName);

  // console.log("selected location in form" , selectedCity)

  const navigate = useNavigate();

  const [data, setData] = useState({
    pageUrl: pageFullUrl,
    cartData: cart,
    servicesName: services,
    totalServices: cart.length,
    servicesQuantity: totalQuantity,
    totalPrice: totalPrice,
    name: "",
    phone: "",
    address: "",
    user: "true",
    status: "true",
    serviceDate: "",
    serviceTime: "",
    selectedCity: selectedCityValue,
    paymentType: "",
  });

  const handleChange = (e) => {
    const value = e.target.value;

    setData({
      ...data,
      [e.target.name]: value,
    });
  };

  const pathOnlyCondition = window.location.pathname;

  const handleNumber = (e) => {
    const value = e.target.value;
    setError(null);

    if (value.length <= 10) {
      setData({
        ...data,
        phone: value,
      });
    }
  };

  const handleDateChange = (e) => {
    const value = e.target.value;
    setData({
      ...data,
      serviceDate: value,
      serviceTime: "",
    });
  };

  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const today = new Date().toISOString().split("T")[0];

  const timeSlots = [
    // { value: '8:00am-10:00am', hour: 8 },
    { value: "10:00am-12:00pm", hour: 10 },
    { value: "12:00pm-2:00pm", hour: 12 },
    { value: "2:00pm-4:00pm", hour: 14 },
    { value: "4:00pm-6:00pm", hour: 16 },
    { value: "6:00pm-8:00pm", hour: 18 },
  ];

  const getFilteredTimeSlots = () => {
    if (data.serviceDate !== today) return timeSlots;
    const currentHour = new Date().getHours();
    return timeSlots.filter((slot) => slot.hour > currentHour);
  };

  const [userAgent, setUserAgent] = useState("");
  const [ipAddress, setIpAddress] = useState(null);

  const getIp = async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");

      if (response.ok) {
        const res = await response.json();
        setIpAddress(res.ip);
      } else {
        console.log(false);
      }
    } catch (error) {
      console.log("error in getting few details");
    }
  };

  useEffect(() => {
    getIp();
    setUserAgent(navigator.userAgent);
  }, []);

  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const updatedData = {
    remoteIP: ipAddress,
    userAgent: userAgent,
  };

  const link = process.env.REACT_APP_API_URL;

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };



  // Curret Featues Working Here

  // const handleSubmit = async (e) => {
  //   setLoading(true);

  //   e.preventDefault();
  //   console.log("data", data);

  //   if (data.phone.length != 10) {
  //     setError("enter the valid number");
  //   } else {
  //     const filledDate = localStorage.getItem("formFilledDate");
  //     const today = getTodayDate();
  //     if (filledDate === today) {
  //       // alert("You've already filled out the form. Please try calling us now.");
  //       alert("You've already filled out the form. Please try calling us now.");
  //     } else {

        
  //       try {
  //         // const response = await fetch("http://localhost:8000/booking-form", {
  //         const response = await fetch(`${link}/booking-form`, {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({ ...updatedData, ...data }),
  //         });

  //         if (response.ok) {
  //           localStorage.setItem("formFilledDate", today);

  //           if (pathOnlyCondition === "/salon-for-women-at-home") {
  //             navigate("/thanks");

  //             window.location.reload();
  //           } else {
  //             navigate("/thank-you");
  //             window.location.reload();
  //           }
  //         } else {
  //           const res_data = await response.json();
  //           alert(res_data.message);
  //         }
  //       } catch (error) {
  //         alert("server error");
  //       }
  //     }
  //   }

  //   setLoading(false);
  // };



const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError(null);

  // 1️⃣ Validate phone number
  if (data.phone.length !== 10) {
    setError("Enter a valid 10-digit number");
    setLoading(false);
    return;
  }

  // 2️⃣ Prevent multiple submissions per day
  const filledDate = localStorage.getItem("formFilledDate");
  const today = new Date().toISOString().split("T")[0];
  if (filledDate === today) {
    alert("You've already filled out the form today. Please try calling us.");
    setLoading(false);
    return;
  }

  const bookingPayload = { ...data, remoteIP: ipAddress, userAgent };

  try {
    // 3️⃣ POSTPAID Booking
    if (data.paymentType === "POSTPAID") {
      const res = await fetch(`${link}/booking-form`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bookingPayload),
      });

      if (!res.ok) throw new Error("Booking failed");

      localStorage.setItem("formFilledDate", today);

      navigate("/thank-you");
       window.location.reload();
       
      setLoading(false);
      return;
    }

    // 4️⃣ PREPAID Booking
    // Load Razorpay script
    const loadRazorpayScript = () => {
      return new Promise((resolve) => {
        if (document.getElementById("razorpay-script")) return resolve(true);
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.id = "razorpay-script";
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
      });
    };

    const scriptLoaded = await loadRazorpayScript();
    if (!scriptLoaded) {
      alert("Razorpay SDK failed to load. Check your internet.");
      setLoading(false);
      return;
    }

    // Create order from backend
    const orderRes = await fetch(`${link}/prepaid/order`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ amount: data.totalPrice}),
    });
    const orderData = await orderRes.json();
    if (!orderData.id) throw new Error("Failed to create order");

    // Razorpay options
    const options = {
      key:"rzp_live_Rua54nfYe0sCYN",
      // key: "rzp_test_Rrn6YlmxnwkSMr",
      amount: orderData.amount,
      currency: "INR",
      name: "Service Booking",
      order_id: orderData.id,

      method: {
        upi: true,
        card: true,
        netbanking: true,
        wallet: false,
      },

      prefill: {
        name: data.name,
        contact: data.phone,
        email: data.email || "",
      },
      handler: async (response) => {
        try {
          // Send payment details to backend
          const bookingRes = await fetch(`${link}/prepaid/booking`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              ...bookingPayload,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            }),
          });

          if (!bookingRes.ok) throw new Error("Booking confirmation failed");

          localStorage.setItem("formFilledDate", today);
          navigate("/thank-you");
            window.location.reload();

         
        } catch (err) {
            alert("Payment successful, but booking failed. Contact support for help.");
        }
      },
      theme: { color: "#0c181eff" },
    };



        const rzp = new window.Razorpay(options);

    rzp.on("payment.failed", (res) => {
      const msg =
        res?.error?.description ||
        res?.error?.reason ||
        "Payment failed. Please try again.";
      alert(msg);
      console.error("Razorpay Error:", res.error);
    });

    rzp.open();
  } catch (err) {
    console.error(err);
    alert(err.message || "Server error");
  } finally {
    setLoading(false);
  }
};




// Chnages Old TESTE CODE bad code bellow :::::::::::::::::::::::::::::::::::

//     const rzp = new window.Razorpay(options);
//     rzp.on("payment.failed", (response) => {
//       console.error("Payment Failed:", response.error);
//       alert("Payment failed. Please try using an Indian test card.");
//     });
//     rzp.open();
//   } catch (err) {
//     console.error(err);
//     alert(err.message || "Server error");
//   }

//   setLoading(false);
// };



// const handleSubmit = async (e) => {
//   e.preventDefault();
//   setLoading(true);
//   setError(null);

//   // 1️⃣ Phone validation
//   if (!/^[6-9]\d{9}$/.test(data.phone)) {
//     setError("Enter a valid 10-digit Indian mobile number");
//     setLoading(false);
//     return;
//   }

//   // 2️⃣ Daily submit limit
//   const today = new Date().toISOString().split("T")[0];
//   if (localStorage.getItem("formFilledDate") === today) {
//     alert("You've already filled the form today. Please call us.");
//     setLoading(false);
//     return;
//   }

//   const bookingPayload = { ...data, remoteIP: ipAddress, userAgent };

//   try {
//     // 3️⃣ POSTPAID FLOW
//     if (data.paymentType === "POSTPAID") {
//       const res = await fetch(`${link}/booking-form`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(bookingPayload),
//       });

//       if (!res.ok) throw new Error("Booking failed");

//       localStorage.setItem("formFilledDate", today);
//       navigate("/thank-you");
//       return;
//     }

//     // 4️⃣ Load Razorpay script
//     const loadRazorpay = () =>
//       new Promise((resolve) => {
//         if (window.Razorpay) return resolve(true);
//         const script = document.createElement("script");
//         script.src = "https://checkout.razorpay.com/v1/checkout.js";
//         script.onload = () => resolve(true);
//         script.onerror = () => resolve(false);
//         document.body.appendChild(script);
//       });

//     if (!(await loadRazorpay())) {
//       alert("Razorpay SDK failed to load");
//       setLoading(false);
//       return;
//     }

//     // 5️⃣ Create ORDER (amount in PAISA)
//     const orderRes = await fetch(`${link}/prepaid/order`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         amount: Math.round(Number(data.totalPrice) * 100),
//       }),
//     });

//     const orderData = await orderRes.json();
//     if (!orderData?.id) throw new Error("Order creation failed");

//     // 6️⃣ Razorpay LIVE options
//     const options = {
//       key: "rzp_live_RrmMQoJGRMbMU5",
//       amount: orderData.amount,
//       currency: "INR",
//       name: "Service Booking",
//       description: "Prepaid service booking",
//       order_id: orderData.id,

//       method: {
//         upi: true,
//         card: true,
//         netbanking: true,
//         wallet: false,
//       },

//       prefill: {
//         name: data.name,
//         contact: data.phone,
//         email: data.email || "",
//       },

//       handler: async (response) => {
//         try {
//           const confirmRes = await fetch(`${link}/prepaid/booking`, {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({
//               ...bookingPayload,
//               razorpay_order_id: response.razorpay_order_id,
//               razorpay_payment_id: response.razorpay_payment_id,
//               razorpay_signature: response.razorpay_signature,
//             }),
//           });

//           if (!confirmRes.ok) throw new Error("Booking save failed");

//           localStorage.setItem("formFilledDate", today);
//           navigate("/thank-you");
//         } catch (err) {
//           alert(
//             "Payment successful but booking failed. Please contact support."
//           );
//         }
//       },

//       theme: { color: "#3399cc" },
//     };

//     const rzp = new window.Razorpay(options);

//     rzp.on("payment.failed", (res) => {
//       const msg =
//         res?.error?.description ||
//         res?.error?.reason ||
//         "Payment failed. Please try again.";
//       alert(msg);
//       console.error("Razorpay Error:", res.error);
//     });

//     rzp.open();
//   } catch (err) {
//     console.error(err);
//     alert(err.message || "Server error");
//   } finally {
//     setLoading(false);
//   }
// };




  return (
    <div>
      {loading ? (
        <div className="data-loading">
          <LoadingComponent />
        </div>
      ) : (
        ""
      )}

      <div className="confirm-booking">
        <div>
          <div className="confirm-booking-close-btn">
            <i
              className="fa-solid fa-circle-xmark"
              onClick={(e) => setConfirmForm(false)}
            ></i>
          </div>
          <div className="confirm-booking-heading">Confirm Booking</div>

          <div className="confirm-booking-form">
            <form onSubmit={handleSubmit}>
              <div className="confirm-booking-form-row">
                <div>
                  <label>Name*</label>
                  <input
                    required
                    type="text"
                    placeholder="Enter Your Name"
                    name="name"
                    onChange={handleChange}
                  />
                </div>

                <div>
                  <label>Number*</label>
                  <input
                    required
                    type="number"
                    placeholder="Enter Your Number"
                    name="phone"
                    onChange={handleNumber}
                    value={data.phone}
                  />
                </div>
              </div>

              <div className="confirm-booking-form-row">
                <div>
                  <label>Grooming Date*</label>
                  <input
                    required
                    type="date"
                    placeholder="*Service Date"
                    min={today}
                    onChange={handleDateChange}
                    value={data.serviceDate}
                    name="serviceDate"
                  />
                </div>

                <div>
                  <label>Grooming Timing*</label>
                  <select
                    required
                    onChange={handleChange}
                    value={data.serviceTime}
                    name="serviceTime"
                  >
                    <option value="" disabled selected>
                      --Select Time--
                    </option>
                    {getFilteredTimeSlots().map((slot) => (
                      <option key={slot.value} value={slot.value}>
                        {slot.value}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div>
                <label>Grooming Address*</label>

                <input
                  type="text"
                  placeholder="Enter Full Address"
                  name="address"
                  value={data.address}
                  onChange={handleChange}
                  required
                ></input>
              </div>

              <div>
                <label>Payment Type*</label>
                <select
                  name="paymentType"
                  value={data.paymentType}
                  onChange={handleChange}
                  required
                >
                  <option value=""  disabled selected>Select</option>
                  <option value="PREPAID">Pre-Paid</option>
                  <option value="POSTPAID">Post-paid</option>
                </select>
              </div>

              {error ? (
                <div className="confirm-booking-form-error">{error}</div>
              ) : (
                ""
              )}

              <button>Book Now</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmBookingForm;
